
import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const BlogDetailPage = lazy(() => import("../pages/blog/detail"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const AdminLoginPage = lazy(() => import("../pages/admin/login"));
const AdminNewPage = lazy(() => import("../pages/admin/new"));
const AdminEditPage = lazy(() => import("../pages/admin/edit"));
const AdminBookingsPage = lazy(() => import("../pages/admin/bookings"));
const AdminChangePasswordPage = lazy(() => import("../pages/admin/change-password"));
const ServiceAreaPage = lazy(() => import("../pages/service-area/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetailPage />,
  },
  {
    path: "/service-area",
    element: <ServiceAreaPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin/new",
    element: <AdminNewPage />,
  },
  {
    path: "/admin/edit/:id",
    element: <AdminEditPage />,
  },
  {
    path: "/admin/bookings",
    element: <AdminBookingsPage />,
  },
  {
    path: "/admin/change-password",
    element: <AdminChangePasswordPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
